import MainLayout from './MainLayout';
import AuthLayout from './AuthLayout';

export default { MainLayout, AuthLayout };
